import { Form } from 'antd';
import React, { forwardRef, useImperativeHandle } from 'react';
import {
  useCrud,
  RESOURCE_ACTION_EDIT,
  RESOURCE_ACTION_CREATE,
  CrudEditContextProvider
} from 'react-structure-admin';

const CrudEdit = (
  {
    children,
    editComponent: EditComponent,
    resource,
    initialValues,
    onCreateOrUpdateSuccess
  },
  ref
) => {
  const { cancelEdit, create, get, post, update, data } = useCrud({
    resource
  });

  const editingRender = () => {
    const [form] = Form.useForm();

    if (!data.editing) {
      return null;
    }

    form.resetFields();

    const editingProps = {
      title: `${data.action !== RESOURCE_ACTION_EDIT ? 'Novo ' : 'Editar '}`,
      resource,
      cancelEdit,
      post,
      update,
      visible: data.editing,
      saving: data.saving,
      action: data.resourceToEdit?.id
        ? RESOURCE_ACTION_EDIT
        : RESOURCE_ACTION_CREATE,
      data: data.resourceToEdit ?? {}
    };

    return (
      <CrudEditContextProvider form={form}>
        <EditComponent
          {...editingProps}
          onCreateOrUpdateSuccess={onCreateOrUpdateSuccess}
        />
      </CrudEditContextProvider>
    );
  };

  const handleClickCreate = (values) => {
    create(values ?? initialValues);
  };

  const handleClickEdit = (id) => {
    if (id) {
      get(id);
    }
  };

  useImperativeHandle(ref, () => ({
    create: handleClickCreate,
    edit: handleClickEdit
  }));

  return (
    <>
      {children}
      {editingRender()}
    </>
  );
};

export default forwardRef(CrudEdit);
